import React from 'react';

interface UpdatedCustomIconProps {
  width?: string;
}

const TickOnboarding: React.FC<UpdatedCustomIconProps> = ({ width }) => (
  <svg
    width={width ?? '100'}
    height={width ?? '100'}
    viewBox='0 0 100 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Frame'>
      <path
        id='Vector'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M66.6633 21.2621C72.1795 15.7949 81.0833 15.8346 86.5505 21.3508C92.0177 26.8671 91.978 35.7708 86.4617 41.238L50.2017 77.1755C44.7203 82.6082 35.8848 82.6082 30.4034 77.1755L13.5383 60.4603C8.02209 54.9933 7.98234 46.0894 13.4495 40.5732C18.9167 35.0571 27.8205 35.0172 33.3367 40.4844L40.3027 47.3883L66.6633 21.2621Z'
        fill='#FF5612'
      />
      <g id='Group'>
        <path
          id='Vector_2'
          d='M38.7398 45.84L33.3364 40.4847C30.1945 37.3707 25.9539 36.0434 21.875 36.4967C24.9162 36.8348 27.8692 38.1632 30.2114 40.4847L37.1773 47.3886L38.7398 45.84Z'
          fill='#FFCCA8'
        />
        <path
          id='Vector_3'
          d='M38.7402 81.1634C42.8207 81.617 47.0616 80.2878 50.2018 77.1755L86.4618 41.238C91.978 35.7708 92.0177 26.867 86.5505 21.3508C83.4048 18.1767 79.1212 16.8159 74.9998 17.2741C78.0823 17.6167 81.0723 18.9764 83.4255 21.3508C88.8927 26.867 88.853 35.7708 83.3368 41.238L47.0768 77.1755C44.7357 79.4959 41.7826 80.8251 38.7402 81.1634Z'
          fill='#FFCCA8'
        />
      </g>
    </g>
  </svg>
);

export default TickOnboarding;
